
export default {
  state: {
    checkoutInfo: {
      orderNotes: '',
      deliveryNotes: '',
      deliveryMessage: 'Meet At Door',
      email: '',
      firstname: '',
      lastname: '',
      phoneNumber: '',
      scheduledTime: '',
      unitNumber: '',
      tipsAmount: 0,
      tipsPercent: 0,
      tipsForStore: 0,
      storeTipsPercentage: 0,
      takeout: null
    }
  },

  getters: {
    getTotal(state, getters) {
      return (getters.getBill.totalAmount || 0) + getters.getTipsAmount + getters.getTipsForStoreAmount
    },

    getTipsAmount(state, getters) {
      return getters.showTips ? state.checkoutInfo.tipsAmount || 0 : 0
    },
    getTipsForStoreAmount(state, getters) {
      return getters.showMultipleTips ? state.checkoutInfo.tipsForStore || 0 : 0
    },

    getCheckoutInfo(state) {
      return state.checkoutInfo
    }
  },

  mutations: {
    SET_CHECKOUT_INFO(state, info) {
      state.checkoutInfo = { ...info }
    }
  },

  actions: {
    setDefaultCheckoutInfoIfEmpty({ state, commit, getters }) {
      const hadEmailAlready = !!state.checkoutInfo.email
      const email = state.checkoutInfo.email || getters.getEmail
      const info = {
        orderNotes: state.checkoutInfo.orderNotes || '',
        deliveryNotes: state.checkoutInfo.deliveryNotes || '',
        deliveryMessage: state.checkoutInfo.deliveryMessage || '',
        email,
        firstname: state.checkoutInfo.firstname || getters.getFirstName,
        lastname: state.checkoutInfo.lastname || getters.getLastName,
        phoneNumber: state.checkoutInfo.phoneNumber || getters.getPhone,
        scheduledDay: state.checkoutInfo.scheduledDay || getters.scheduledDay,
        scheduledTime: state.checkoutInfo.scheduledTime || getters.scheduledTime,
        tipsAmount: state.checkoutInfo.tipsAmount || 0,
        tipsPercent: state.checkoutInfo.tipsPercent || 0,
        tipsForStore: state.checkoutInfo.tipsForStore || 0,
        storeTipsPercentage: state.checkoutInfo.storeTipsPercentage || 0,
        // Re-derive from the email only while the email field itself is
        // still being defaulted in (hadEmailAlready is false) -- this action
        // fires many times (route guards, order-type switches, etc.), often
        // before the logged-in customer's profile/email has finished
        // loading. That first call locks in emailReceipt: false against a
        // still-empty email; without hadEmailAlready, every later call would
        // see emailReceipt !== undefined and wrongly keep that false even
        // once the real email arrives. Once email is genuinely present
        // (hadEmailAlready), preserve whatever's there -- that's either the
        // customer's own explicit toggle or the correct auto-derived value
        // from the call where the email first appeared.
        emailReceipt: hadEmailAlready ? state.checkoutInfo.emailReceipt : !!email,
        selectedPayMethodId: state.checkoutInfo.selectedPayMethodId || null,
        unitNumber: state.checkoutInfo.unitNumber || null,
        takeout: state.checkoutInfo.takeout || null
      }

      commit('SET_CHECKOUT_INFO', info)
    },

    clearCheckoutInfo({ state, commit }) {
      const info = {
        orderNotes: '',
        deliveryNotes: '',
        deliveryMessage: '',
        email: '',
        firstname: '',
        lastname: '',
        phoneNumber: '',
        scheduledTime: '',
        scheduledDay: '',
        tipsAmount: 0,
        tipsPercent: 0,
        tipsForStore: 0,
        storeTipsPercentage: 0,
        // email is reset to '' above -- no address to receive a receipt at.
        emailReceipt: false,
        paymentMethods: [],
        selectedPayMethodId: null,
        unitNumber: state.checkoutInfo.unitNumber || '',
        takeout: null
      }

      commit('SET_CHECKOUT_INFO', info)
    },

    clearScheduledTimeandDay({ state, commit }) {
      const info = {
        ...state.checkoutInfo,
        scheduledTime: '',
        scheduledDay: ''
      }

      commit('SET_CHECKOUT_INFO', info)
    }
  }
}
